import $ from "jquery"; /*引入jquery*/
import { justOpenMini } from "./openMini"; /*引入 唤起小程序 模块*/
import getCookie from "../common/getCookieValue";
import getURLParameter from "../common/getURLParameter";

const spm = getCookie("spm") || "";
const { wechatJump = "", creativeid = "" } = getURLParameter();

function drawHtml(flag) {
    return `
        <section class="baidu_container">
            <div class="baidu_mask" style="display: ${flag ? "none" : "block"}">
                <div class="baidu_dialog">
                    <p>
                        打开58招聘微信小程序
                    </p>
                    <ul>
                        <li class="confirm">现在打开</li>
                        <li class="cancel">以后再说</li>
                    </ul>
                </div>
            </div>
            <div class="baidu_float"  style="display: ${
                flag ? "block" : "none"
            }">
                <img src="//img.58cdn.com.cn/crop/biz/m/lunaHome/pic/img/logo.png" alt="" width="20" />
                <span>
                    打开58微信小程序
                </span>
            </div>
        </section>
    `;
}

export function drawBaiduDialog() {
    if (
        creativeid === "1" &&
        wechatJump === "1" &&
        (spm.includes("u-2by5ssayp3v43nkdq9g") ||
            spm.includes("u-2few7p4vh988mb62t1"))
    ) {
        const flag = localStorage.getItem("baidu_wechat_flag");

        if (flag) {
            justOpenMini(["u-2by5ssayp3v43nkdq9g", "u-2few7p4vh988mb62t1"]);
        }

        return drawHtml(flag);
    }

    return "";
}

export function eventBindBaiduDialog() {
    function cancel() {
        $(".baidu_mask").css("display", "none");
        $(".baidu_float").css("display", "block");
    }

    $(".baidu_dialog")
        .on("click", ".confirm", () => {
            justOpenMini(["u-2by5ssayp3v43nkdq9g", "u-2few7p4vh988mb62t1"]);

            localStorage.setItem("baidu_wechat_flag", true);

            cancel();
        })
        .on("click", ".cancel", cancel);

    $(".baidu_float").on("click", () => {
        justOpenMini(["u-2by5ssayp3v43nkdq9g", "u-2few7p4vh988mb62t1"], true);

        localStorage.setItem("baidu_wechat_flag", true);
    });
}
